const focus = {
    mounted(element) {
        element.focus();
    }
}

export { focus }